export default {
  methods: {
    countCartByCategory(category) {
      let cart = this.$store.state.cart.selectedProducts
      let count = cart.reduce((a, c) => {
        if (category == c.category) {
          return a + c.items
        }
        return a
      }, 0)
      return count
    },
    maxPerCategory(category) {
      return this.$store.getters['product/getLimitPerCategory'][category] || 9999
    },
    canAdd(category) {
      let count = this.countCartByCategory(category)
      let max = this.maxPerCategory(category)
      if (max) {
        return max - count
      }
      return 9999
    },
    countCartByProductId(id) {
      let cart = this.$store.state.cart.selectedProducts
      let product = cart.find(p => p.id == id && p.category != '[PROMO]')
      if (product) return product.items
      return 0
    },
    canAddProduct(product) {
      let count = this.countCartByProductId(product.id)
      let max = product.stock
      if (max) {
        return max - count
      }
      return 9999
    },
    onSuccess () {
      console.log('respon dari action mixin')
    }
  },
}
